import { createContext, useState } from "react";

export const BrandingContext = createContext();

export const BrandingProvider = ({ children, brandingData }) => {
  return (
    <BrandingContext.Provider value={brandingData}>
      {children}
    </BrandingContext.Provider>
  );
};
